import { Controller } from '@hotwired/stimulus';

// One upload slot on the add-on form: click or drop a file, see it immediately,
// replace it, or remove it.
//
// The file input is the real control and is never bypassed -- a drop writes the
// dropped file into it through a DataTransfer, so the form posts exactly what it
// would have if you had used the file picker. "Remove" cannot be done that way
// (there is no empty value you can post to a file input), so it sets a hidden
// flag the controller reads as an instruction.
export default class extends Controller {
  static targets = ['input', 'preview', 'figure', 'empty', 'remove'];

  static values = { main: Boolean };

  pick(event) {
    // Replace/Remove sit inside the slot; only a click on the slot itself, or on
    // the Replace button, should open the picker.
    if (event.target.closest('.aa-slot-remove')) return;
    if (this.hasFigureTarget && !this.figureTarget.hidden && !event.target.closest('button')) return;

    this.inputTarget.click();
  }

  chosen() {
    const file = this.inputTarget.files && this.inputTarget.files[0];
    if (!file) return;

    this.removeTarget.value = '0';
    this.show(URL.createObjectURL(file));
  }

  remove(event) {
    event.preventDefault();
    event.stopPropagation();

    this.inputTarget.value = '';
    this.removeTarget.value = '1';
    this.hide();
    this.announce('');
  }

  dragOver(event) {
    event.preventDefault();
    this.element.classList.add('is-over');
  }

  dragLeave() {
    this.element.classList.remove('is-over');
  }

  drop(event) {
    event.preventDefault();
    this.element.classList.remove('is-over');

    const file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
    if (!file || !file.type.startsWith('image/')) return;

    // Hand the dropped file to the real input so the form submits normally.
    const transfer = new DataTransfer();
    transfer.items.add(file);
    this.inputTarget.files = transfer.files;

    this.removeTarget.value = '0';
    this.show(URL.createObjectURL(file));
  }

  show(url) {
    this.previewTarget.src = url;
    this.figureTarget.hidden = false;
    this.emptyTarget.hidden = true;
    this.element.classList.add('is-filled');
    this.announce(url);
  }

  hide() {
    this.previewTarget.src = '';
    this.figureTarget.hidden = true;
    this.emptyTarget.hidden = false;
    this.element.classList.remove('is-filled');
  }

  // Only the MAIN image appears on the store card, so only it tells the form.
  announce(url) {
    if (!this.mainValue) return;

    this.element.dispatchEvent(new CustomEvent('addon:image-changed', { bubbles: true, detail: { url } }));
  }
}
